import React from "react";
import ReactSelect from "@ui/ReactSelect";
import { useSuspectedElementInput } from "./useSuspectedElementInput";

interface P {
  projectId: string;
  focusableRef: React.RefObject<{
    focus: () => void;
  }>;
  name: string;
  placeholder: string;
  entry: { suspectedElements: { suspectedElement: { name: string; id: string } }[] };
  column: string;
  allowSuspectedElementCreation?: boolean;
  setDirty: (dirty: boolean, column: string) => void;
}

const SuspectedElementSelect = ({
  projectId,
  name,
  placeholder,
  setDirty,
  entry,
  allowSuspectedElementCreation = false,
  ...props
}: P) => {
  const suspectedElementsInput = useSuspectedElementInput(projectId, [entry]);

  React.useEffect(() => {
    setDirty(suspectedElementsInput.dirty, props.column);
  }, [suspectedElementsInput.dirty, props.column, setDirty]);

  return (
    <ReactSelect
      {...props}
      menuPortalTarget={window.document.body}
      ref={props.focusableRef as React.RefObject<HTMLDivElement>}
      isMulti
      name={name}
      placeholder={placeholder}
      value={suspectedElementsInput.selectedSuspectedElements}
      options={suspectedElementsInput.suspectedElementOptions}
      onChange={suspectedElementsInput.handleSuspectedElementChanged}
      onCreate={
        allowSuspectedElementCreation
          ? suspectedElementsInput.handleSuspectedElementCreated
          : undefined
      }
      onEdit={
        allowSuspectedElementCreation
          ? suspectedElementsInput.handleSuspectedElementEdited
          : undefined
      }
      onDelete={
        allowSuspectedElementCreation
          ? suspectedElementsInput.handleSuspectedElementDeleted
          : undefined
      }
    />
  );
};

export default React.memo(SuspectedElementSelect);
